
import { useSelector } from "react-redux"
import styled from "styled-components"
import EqualAracSide from "../frameAracSide/EqualAracSide"
import WideAracSide from "../frameAracSide/WideAracSide"
import AracColumnBtn from "../frameAracSide/AracColumnBtn"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { getGunlukAracList } from "../../../features/joblist/jobListSlice"

const Container = styled.div`
    width: ${({width}) => width};
    transition: 1s;
    position: relative;
`


const AracFrames = () => {

    const {frameState, gunlukAracList, isLoadingGunlukAracList, yukBekleyenAracCheckedItemList, gunlukAraclarFilterValues} = useSelector(state => state.jobList)
    const {plakaSearch, aracTuruValue, cityCanGo, rateFilter} = gunlukAraclarFilterValues
    const { loadList } = useSelector((state) => state.loadList);

    const dispatch = useDispatch()

    useEffect(()=> {
      dispatch(getGunlukAracList({Plate:plakaSearch || "", CityCanGo: cityCanGo?.value || "", TruckType: aracTuruValue?.name || "", Star:rateFilter?.id || "" }))
    },[plakaSearch, cityCanGo, aracTuruValue,rateFilter, dispatch])


  return (
    <Container width={frameState === "equal" ? "50%" : frameState === "aracSide" ? "calc(100% - 110px)" : frameState === "yukSide" && "80px"}>
          {
            frameState === "equal" && 
            <EqualAracSide list={gunlukAracList} isLoading={isLoadingGunlukAracList} checkedItemList={yukBekleyenAracCheckedItemList.map(item => item.id)} loadList={loadList}/>
          }
          {
            frameState === "aracSide" && 
            <WideAracSide list={gunlukAracList} isLoading={isLoadingGunlukAracList} checkedItemList={yukBekleyenAracCheckedItemList.map(item => item.id)} loadList={loadList}/>
          }
          {
            frameState === "yukSide" &&
            <AracColumnBtn />
          }
    </Container>
  )
}

export default AracFrames